<template>
  <div ref="tableDatabox" class="tableData">
    <el-table
      ref="targetTable"
      v-loading="loading"
      :data="tableData"
      :border="border"
      :max-height="maxHeight"
      :header-cell-style="headClass"
      row-class-name="cellClass"
      :cell-style="setSellStyle"
      :show-summary="showSummary"
      :sum-text="sumText"
      :row-key="rowKey"
      :tree-props="treeProps"
      :summary-method="summaryMethod"
      @selection-change="handleSelectionChange"
      @sort-change="sortthiscolumn"
      @toggleAllSelection="toggleAllSelection"
    >
      <el-table-column v-if="isShowIndex" type="index" label="" />
      <el-table-column v-if="isShowSelection" type="selection" width="55" />
      <el-table-column
        v-for="(item, index) in newData"
        :key="item.prop + item.label"
        :type="item.type"
        :prop="item.prop"
        :label="item.label"
        :fixed="item.fixed"
        :width="item.labelWidth"
        :min-width="item.minWidth"
        :align="item.align"
        :class-name="item.className"
        :sortable="item.sortable"
        :render-header="renderHeader"
      >
        <template slot-scope="scope">
          <slot v-if="item.slot" :name="item.prop" :row="scope.row" :index="index"></slot>
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
      <slot name="dynamic"></slot>
      <slot name="operation"></slot>
    </el-table>
  </div>
</template>
<!-- eslint-disable indent -->
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    isShowSelection: {
      type: Boolean,
      default: false
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    sumText: {
      type: String,
      default: '合计'
    },
    rowKey: {
      type: [Number, String],
      default: 'id'
    },
    treeProps: {
      type: Object,
      default: () => {}
    },
    summaryMethod: {
      type: Function,
      default: ({ columns, data }) => {}
    },
    tableData: {
      type: Array,
      required: false,
      default: () => []
    },
    tableHeadData: {
      type: Array,
      required: false,
      default: () => []
      /**
       * 属性
       * prop: 'time'            字段名
       * label: '流转起止时间'     label名城
       * slot: true              是否开启自定义格式
       * labelWidth: 200         列宽
       * sortable: 'custom'      排序模式  custom true/false 设置为custom需配合远程排序 sort-change
       * fixed: true             开启固定列
       * minWidth: 200           列最小宽度
       * align: center           对齐方式  right/left
       * className: string       列的className
       * hidden: Boolean         是否隐藏此列，用于动态表格
       * */
    },
    // 是否显示序号
    isShowIndex: {
      type: Boolean,
      required: false,
      default: false
    },
    // 表头后面是否显示复选框
    isSetChecked: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      newData: [],
      targetEv: [],
      maxHeight: 800
    }
  },
  mounted() {
    window.onresize = () => {
      this.calHeight()
    }
    this.calHeight()
    const tableHeadData = this.tableHeadData.filter((item) => !item.hidden)
    this.newData = tableHeadData
  },
  methods: {
    toggleAllSelection(item) {
      this.$emit('toggleAllSelection', item)
    },
    handleSelectionChange(item) {
      this.$emit('handleSelectionChange', item)
    },
    calHeight() {
      this.$nextTick(() => {
        if (!this.$refs.tableDatabox) return
        const rect = this.$refs.tableDatabox.getBoundingClientRect()
        this.maxHeight = rect.height - 10
      }, 300)
    },
    setSellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'borderRadius: 8px 0 0 8px;'
      }
      if (column.label === '操作') {
        return 'borderRadius: 0 8px 8px 0;'
      }
    },
    headClass() {
      return 'backgroundColor: #F2F7FF; border: none;'
    },
    sortthiscolumn({ column, prop, order }) {
      this.$emit('sortthiscolumn', column, prop, order)
    },
    renderHeader(h, { column }) {
      const propList = ['id']
      if (this.isSetChecked) {
        const property = column.property
        return h('div', [
          h('span', column.label),
          propList.indexOf(column.property) > -1
            ? null
            : h('el-checkbox', {
                style: 'margin-left:5px',
                on: {
                  change: ($event, column) => this.select($event, column, property) // 选中事件
                }
              })
        ])
      } else {
        return h('div', [h('span', column.label)])
      }
    },
    select(checked, column, property) {
      this.newData.map((item) => {
        if (item.prop === property) {
          item.checked = checked
        }
      })
      this.$emit('changeCheckbox', this.newData)
    }
  }
}
</script>

<style lang="scss" scoped>
.tableData {
  width: 100%;
  position: relative;
  flex: 1;
  overflow: auto;
}
::v-deep .el-table {
  position: absolute;
}
// ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
//   width: 0 !important;
// }
::v-deep .el-table__body-wrapper {
  // overflow: -moz-scrollbars-none;
  // -ms-overflow-style: none;
}
::v-deep .cellClass {
  // background-color: #f6f8ff;
  border-bottom: 1px solid #f3f3f4;
}
::v-deep .el-table__body .el-table__row.hover-row td {
  background: #e8fbff;
}
::v-deep .el-table td.el-table__cell {
  padding: 5px 0;
  border-bottom: 1px solid #f3f3f4;
}
::v-deep .el-table__body {
  border-collapse: separate !important;
  // border-spacing: 0 15px !important;
  table-layout: auto !important;
  // margin-top: -15px;
}
::v-deep .el-table::before {
  display: none;
}
::v-deep .el-table__fixed-right {
  &::before {
    height: 0;
  }
}
::v-deep.el-table th.el-table__cell > .cell {
  display: flex;
  vertical-align: middle;
  line-height: 34px;
  // align-items: center;
  // justify-content: center;
}
</style>
